<template>
  <BreadCrumb PageTitle="Contacts" />
  <ContactsContent />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import ContactsContent from "../../template-components/SupportDesk/Contacts/ContactsContent.vue";

export default defineComponent({
  name: "ContactsPage",
  components: {
    BreadCrumb,
    ContactsContent,
  },
});
</script>